import { render, staticRenderFns } from "./UiButtonGroup.vue?vue&type=template&id=546a99b4"
import script from "./UiButtonGroup.vue?vue&type=script&lang=js"
export * from "./UiButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./UiButtonGroup.vue?vue&type=style&index=0&id=546a99b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports